import { render, staticRenderFns } from "./reviewPlan.vue?vue&type=template&id=23da5adb&scoped=true"
import script from "./reviewPlan.vue?vue&type=script&lang=js"
export * from "./reviewPlan.vue?vue&type=script&lang=js"
import style0 from "./reviewPlan.vue?vue&type=style&index=0&id=23da5adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da5adb",
  null
  
)

export default component.exports